import React from 'react'
// import Dashnav from '../components/dashnav'
// import Democarasol from '../components/caraso/l'

class Landingpage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
  }

  componentDidMount () {
  }

  render () {
    return (
      <div>
        home
      </div>
    )
  }
}
export default Landingpage